import { Signal } from './Signal';

// 对父窗口而言，这些是我们要发送给游戏的指令
export const COMMANDS = Object.freeze({
    INIT: "INIT",
    TOKEN: "TOKEN",
    SET_BALANCE: "SET_BALANCE",
    SET_MUTE: "SET_MUTE",
    SET_FULLSCREEN: "SET_FULLSCREEN",
    LCID_STRING: "LCID_STRING",
    SETTINGS_CLICK: "SETTINGS_CLICK"
});

// 对父窗口而言，这些是我们要监听游戏发来的事件
export const GAME_EVENTS = Object.freeze({
    INIT: "INIT",
    TOKEN_REQUEST: "TOKEN_REQUEST",
    LOAD_PROGRESS: "LOAD_PROGRESS",
    BALANCE_NOT_ENOUGH: "BALANCE_NOT_ENOUGH",
    BALANCE_CHANGE: "BALANCE_CHANGE",
    FULLSCREEN_CLICK: "FULLSCREEN_CLICK",
    MUTE_CHANGE: "MUTE_CHANGE",
    GAME_BOOTED: "GAME_BOOTED",
    BET_CHANGE: "BET_CHANGE",
    SPIN: "SPIN",
    SPIN_ANIMATION_COMPLETED: "SPIN_ANIMATION_COMPLETED",
    LCID_STRING_REQUEST: "LCID_STRING_REQUEST"
});

export class ParentMessageBridge {
    /**
     * @param {HTMLIFrameElement} iframeElement - 游戏的 iframe 元素
     * @param {string} targetOrigin - 游戏的域名 (例如 "https://game.com")，用于安全校验
     */
    constructor(iframeElement, targetOrigin = "*") {
        if (!iframeElement) throw new Error("iframeElement is required");
        
        this.iframe = iframeElement;
        this.targetOrigin = targetOrigin;
        this._signals = {};

        // 监听来自 iframe 的消息
        window.addEventListener("message", this._onMessageEvent.bind(this));
    }

    /**
     * 向游戏发送指令 (对应原 bridge 的 IN_EVENTS)
     */
    send(type, data = {}) {
        const payload = { ...data, type };
        
        // 校验是否为合法的指令
        if (!Object.values(COMMANDS).includes(type)) {
            console.warn("Sending non-standard command to game:", type);
        }

        if (this.iframe.contentWindow) {
            this.iframe.contentWindow.postMessage(payload, this.targetOrigin);
        }/*else {
            console.error("Game iframe contentWindow is not available");
        }*/
    }

    _onMessageEvent(event) {
        // 安全校验：如果设置了 targetOrigin，则只接收来自该域名的消息
        if (this.targetOrigin !== "*" && event.origin !== this.targetOrigin) return;

        const data = event.data;
        if (!data || typeof data.type !== "string") return;

        // 触发对应的信号监听器
        if (this._signals[data.type]) {
            this._signals[data.type].dispatch(data);
        }
    }

    /**
     * 监听游戏发出的特定事件 (对应原 bridge 的 OUT_EVENTS)
     */
    on(type) {
        if (!Object.values(GAME_EVENTS).includes(type)) {
            console.warn("Subscribing to non-standard game event:", type);
        }
        if (!this._signals[type]) {
            this._signals[type] = new Signal();
        }
        return this._signals[type];
    }
}